import styled from 'styled-components';

export const Wrapper = styled.div`
display: flex;
align-items: center;
white-space: nowrap;
min-width: 120px;

.dv-star-rating-empty-star {
  i {
    font-size: ${p => p.size || '20px'};
    line-height: ${p => p.size || '20px'};
    color: #E3E3E3;
  }
  padding: 0px;
  margin-bottom: 0px;
}

.dv-star-rating-full-star {
  i {
    font-size: ${p => p.size || '20px'};
    line-height: ${p => p.size || '20px'};
    color: #FFC700;
  }
  padding: 0px;
  margin-bottom: 0px;
}
`;
